<div *ngIf="options.length" class="detail-container align-items-center my-2">
  <morva-icons icon="chartInfo" class="mx-2"></morva-icons>
  <p class="ms-4">جزئیات</p>
  <div class="details-options">
    <p *ngFor="let option of options">{{option.name}}: {{option.count | persianNumber}} عدد</p>
  </div>
</div>
